baseApp.directive('confirm', function() {
    return {
        templateUrl: '/public/directives/confirm.html',
        controller: function($scope) {
        }
    };
});